import script from "./legend-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./legend-list.vue?vue&type=script&setup=true&lang=ts"

import "./legend-list.vue?vue&type=style&index=0&id=0b5b13f2&lang=scss"

const __exports__ = script;

export default __exports__